require("./ServicesTab.less");
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import {setElementsFromScope, show, hide} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";
import ProductLevelServicesView from "./ProductLevelServicesView";
import ShipmentLevelServicesView from "./ShipmentLevelServicesView";
import ReviewServicesView from "./ReviewServicesView";
import ServiceStore from "../../../stores/CmrServiceStore";
import calcSubTotalServicesForAsnId from "../businessLogic/calcSubTotalServicesForAsnId";
import {toCurrency} from "../../../utilities/currency";

const elementsMap = {
  productServicesEntryPoint: '.product-services-entry-point',
  shipmentServicesEntryPoint: ".shipment-services-entry-point",
  reviewServicesOuter: ".review-services-outer",
  subTotal: ".sub-total-currency"
};

export default function ServicesTab(wizard, {scopeElement, readOnly}={}){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  if(!scopeElement){
    scopeElement = wizardElement.find('.services-tab');
  }

  const els = {};



  self.init = function(){
    setElements();
    attachWidgets();
    updateSelf();
    bindElements();
    bindStores();
  };



  function setElements(){
    setElementsFromScope(els, elementsMap, scopeElement);
  }

  function attachWidgets(){
    const productLevelServicesView = new ProductLevelServicesView(els.productServicesEntryPoint, {readOnly});
    productLevelServicesView.init();
    const shipmentLevelServicesView = new ShipmentLevelServicesView(els.shipmentServicesEntryPoint, {readOnly});
    shipmentLevelServicesView.init();
    const reviewServicesView = new ReviewServicesView(els.reviewServicesOuter, {calcSubTotal, readOnly});
    reviewServicesView.init();
  }

  function bindElements(){

  }



  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);

    AsnDetailStore.bindListener("asn_details:add", updateSelf);
    AsnDetailStore.bindListener("asn_details:remove", updateSelf);
    AsnDetailStore.bindListener("asn_details:change", updateSelf);

    ServiceStore.bindListener("cmr_services:add", updateSelf);
    ServiceStore.bindListener("cmr_services:remove", updateSelf);
    ServiceStore.bindListener("cmr_services:change", updateSelf);



  }

  function updateSelf(){
    updateText();
  }

  function updateText(){
    els.subTotal.text(calcSubTotal());
  }

  function calcSubTotal(){
    const val = calcSubTotalServicesForAsnId(getAsnId());
    return toCurrency(val);
  }

  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getAsnId(){
    return getAsn().id;
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ServicesTab.js